import type {PropagatorType, TracingOption} from '@datadog/browser-rum';

export type GlobalViewer = {
  id: string;
  username?: string;
  entity: string;
  org?: string;
};

declare global {
  interface Window {
    // This matches what's in app/src/util/window.ts
    viewer: GlobalViewer | undefined;
  }
}

// A string entry matches every request URL that starts with it (browser-rum-core
// tracer.ts, matchList with useStartsWith), so an origin covers all its paths.
//
// Under the Forge shell the app calls gorilla, weave and trace same-origin on
// the shell host (/api/wandb, /api/weave, /api/trace; REACT_APP_SHELL_*_HOST in
// environments/*.env), and the platform load balancer forwards those to the
// api./weave./trace. hosts below. Listing the shell origin is what gets the
// b3 headers, and so @_dd.trace_id, onto those resource events.
const ALLOWED_TRACING_URL_PATTERNS = [
  // local dev
  'http://api.wandb.test',
  'https://api.wandb.test',
  'https://weave.wandb.test',
  'https://trace.wandb.test',
  'https://trace-server.wandb.test',
  'https://forge.wandb.test',

  // qa
  'https://api.qa.wandb.ai',
  'https://weave.qa.wandb.ai',
  'https://trace.qa.wandb.ai',
  'https://weave-trace.qa.wandb.ai',
  'https://qa.forge.coreweave.com',

  // prod
  'https://api.wandb.ai',
  'https://weave.wandb.ai',
  'https://trace.wandb.ai',
  'https://forge.coreweave.com',
];

const B3MULTI: PropagatorType = 'b3multi';

export const ALLOWED_TRACING_URLS: TracingOption[] =
  ALLOWED_TRACING_URL_PATTERNS.map(url => ({
    match: url,
    propagatorTypes: [B3MULTI],
  }));

export const DATADOG_RUM_APPLICATION_ID =
  '70585d24-006d-424f-a3c5-fbe0403f9ebf';
export const DATADOG_CLIENT_TOKEN = 'pub44b08232e19f1a1651a49e62607b9fcd'; //gitleaks:allow
export const DATADOG_SITE = 'us5.datadoghq.com';
export const DATADOG_UI_SERVICE = 'wandb-web-ui';
